import React from 'react';
import { Grid } from 'packages/ds/Grid/Grid';
import CategoryCard from 'packages/pages/components/categories/CategoryCard';
import { InfinityLoader } from 'packages/pages/components/InfinityLoader/InfinityLoader';
import { Category } from 'packages/store/categories/types';
import { AllowedIndicatorTypes } from 'packages/pages/components/templates/types';

type Props = {
    categories: Category[];
    contextAction?: (category: Category) => React.ReactNode;
    onClick?: (category: Category) => void;
    isLoading: boolean;
    totalItems: number;
    loadMore: () => void;
    to: (category: Category) => string;
    allowedIndicatorTypes: Omit<AllowedIndicatorTypes, 'folder'> & { folder?: false };
};

const CategoriesGrid = ({
    categories,
    contextAction = null,
    onClick = null,
    isLoading,
    totalItems,
    loadMore,
    to,
    allowedIndicatorTypes,
}: Props) => (
    <>
        <Grid variant="masonry">
            {categories.map((category) => (
                <CategoryCard
                    key={category.id}
                    category={category}
                    contextAction={contextAction ? contextAction(category) : undefined}
                    onClick={onClick ? () => onClick(category) : undefined}
                    to={to(category)}
                    allowedIndicatorTypes={allowedIndicatorTypes}
                />
            ))}
        </Grid>
        <InfinityLoader isLoading={isLoading} count={categories.length} totalItems={totalItems} loadMore={loadMore} />
    </>
);

export default CategoriesGrid;
